import React, { useState } from "react"
import { useCookies } from 'react-cookie';
import Sidebar from './SideBar';
import useAuthRedirect from "./Componentes/auth";
import DriveView from './Componentes/DriveView'; // Vista principal del drive
import './ccss/Files.css';

const cardImages = {
    DAFA: "/img/dafaLogo.png",
    FUGA: "/img/fugarLogo.png",
    INVE: "/img/idafaLogo.png",
    TRAN: "/img/extasisLogo.png",
    NIDI: "/img/nidiamLogo.png"
};


function Layout() {
    useAuthRedirect();
    const [cookies] = useCookies(['selectedCard']);
    const imageUrl = cardImages[cookies.selectedCard]
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);
    const [isAdministracionCollapsed, setIsAdministracionCollapsed] = useState(true);
    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prevState => !prevState);
    };
    return (

        <body id="page-top">
            <div id="wrapper">
                <Sidebar
                    imageUrl={imageUrl}
                    isComponentsCollapsed={isComponentsCollapsed}
                    toggleCollapse={toggleCollapse}
                    setIsComponentsCollapsed={setIsComponentsCollapsed}
                    isUtilitiesCollapsed={isUtilitiesCollapsed}
                    setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                    isInventario={isInventario}
                    setisIventatioCollapsed={setisIventatioCollapsed}
                    isPrevencion={isPrevencion}
                    setisPrevencionCollapsed={setisPrevencionCollapsed}
                    isLogistica={isLogistica}
                    setisLogisticaCollapsed={setisLogisticaCollapsed}
                    isContabilidadCollapsed={isContabilidadCollapsed}
                    setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                    isAdministracionCollapsed={isAdministracionCollapsed}
                    setIsAdministracionCollapsed={setIsAdministracionCollapsed}
                    cookies={cookies}
                />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            <div class="row">
                                <DriveView />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </body>
    );
}

export default Layout;
